const Dcn = {
  symbol: 'dcn',
  color: '#000',
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" r="16" fill="#136485"/><path fill="#FFF" d="M10.436 31.006a16.008 16.008 0 01-5.604-3.548l.147-.257c2.388-3.773 4.533-7.678 6.148-11.85 1.713-4.425 3.084-8.967 4.39-13.527.117-.407.256-.807.384-1.21.138.158.188.305.23.454.82 2.926 1.613 5.86 2.464 8.776 1.55 5.313 3.73 10.353 6.617 15.077.337.55.91 1.472 1.72 2.762a15.988 15.988 0 01-6.035 3.554 4320.193 4320.193 0 00-5.002-15.17l-.154-.002c-1.166 3.277-2.934 8.257-5.305 14.941zM16.075.049h-.124L16 0l.075.049z"/></g>`;
  },
  plainIcon: c => {
    return `<path fill-rule="evenodd" fill="${
      c ? c : this.color
    }" fill-rule="evenodd" d="M4.774 27.4A15.951 15.951 0 010 16C0 7.163 7.163 0 16 0s16 7.163 16 16c0 4.61-1.95 8.763-5.068 11.683a311.58 311.58 0 01-1.72-2.762c-2.888-4.724-5.068-9.764-6.617-15.077-.85-2.917-1.644-5.85-2.464-8.776a1.076 1.076 0 00-.23-.455c-.128.404-.267.804-.383 1.21-1.307 4.561-2.678 9.103-4.391 13.528-1.584 4.092-4.008 8.328-6.353 12.05zM21.147 32h-7.63l-3.146-.812a21751.8 21751.8 0 015.37-15.123l.154.003A4716.12 4716.12 0 0121.147 32z"/>`;
  }
};
export default Dcn;
